import * as React from 'react';
import { get } from 'lodash';
import Camera from 'material-ui/svg-icons/image/camera-alt';
import FilterList from 'material-ui/svg-icons/content/filter-list';

import { ModalButton } from '@components/modalButton/ModalButton';
import { EventsGridProlaserForm } from './EventsGridProlaserForm';
import { EnhancedExportButton } from '@components/exportButton/ExportButton';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';
import { duplicateEvent } from '@modules/events/_eventsActions';
import { getConfigurationContext } from '@components/provider/configuration/ConfigurationProvider';
import { FiltersMemoryForm } from '@components/filtersMemory/FiltersMemoryForm';
import { parseBool } from '@utils/utils';

const ActionsBar: React.FC<Record<string, any>> = ({ state, checkedItems, filters, setFilters, columns }) => {
  const { config } = getConfigurationContext();

  const duplicate = parseBool(get(config, 'extensions.duplicate', false));
  const filtersmemory = parseBool(get(config, 'extensions.filtersmemory', false));

  const handleDuplicate = async () => {
    const newId = await duplicateEvent(checkedItems.at(0).id);

    if (newId) {
      window.location.replace(`/events?item=${newId}`);
    }
  };

  return (
    <React.Fragment>
      {duplicate && (
        <Button
          label="Duplikovat"
          onClick={handleDuplicate}
          disabled={checkedItems.length !== 1}
          style={{ marginLeft: 10 }}
        />
      )}
      {filtersmemory && (
        <ModalButton
          label="Paměť filtrů"
          icon={<FilterList />}
          ModalComponent={FiltersMemoryForm}
          module="events"
          filters={filters}
          setFilters={setFilters}
          columns={columns}
          style={{ marginLeft: 5 }}
        />
      )}
      <ColumnManager agenda={Agenda.EVENTS} />
      <EnhancedExportButton location={'eventOverview'} params={state} />
      <ModalButton
        label={'Prolaser'}
        icon={<Camera />}
        ModalComponent={EventsGridProlaserForm}
        style={{ marginLeft: 5 }}
      />
    </React.Fragment>
  );
};

export default ActionsBar;



// WEBPACK FOOTER //
// ./src/modules/events/EventsGridButtons.tsx